<template>
  <div class="atom-subnav-link">
    <SlotLink :url="url" class="atom-subnav-link__link">
      {{ data.label }}
    </SlotLink>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

// get the url without the last slash
const url = computed(() => (
    props.data.link.cached_url.charAt(props.data.link.cached_url.length - 1) === '/'
        ? props.data.link.cached_url.slice(0, -1)
        : props.data.link.cached_url
));
</script>

<style lang="scss">
.atom-subnav-link {
    @include typo-size('nav');
    @include typo-font('bold');
    @include fluid('margin-right', 22px, 42px);

    &:first-child {
        @include fluid('padding-left', 0px, 53px);

    }

    &:last-child {
        @include fluid('padding-right', 0px, 53px);
    }

    white-space: nowrap;

    .atom-subnav-link__link {
        position: relative;
        color: $C_PRIMARY;
        transition: color 0.1s ease-in-out;

        &:hover {
            color: $C_SECONDARY;
        }

        &.router-link-exact-active{
            color: $C_GREEN_DARK;

            &:after {
                position: absolute;
                bottom: -7px;
                left: 0;
                width: 30px;
                border: 1px solid $C_GREEN_DARK;
                border-radius: 100px;
                content: '';
                opacity: 1;
            }
        }
    }
}
</style>
